import Text from 'components/Text/Text';
import React, { useContext, useRef } from 'react';
import { Select } from 'antd';
import { TTypeOfServiceProvided } from 'types';
import { clientTypes } from 'appConstants';
import breadcrumbs from 'images/breadcrumbs.svg';
import { useTranslation } from 'react-i18next';
import { RestaurantsContext, IRestaurantsContext } from '../../../restaurantsState/restaurantsContext';
import style from './ClientTypeMultipleSelect.module.scss';

const { Option } = Select;

const ClientTypeMultipleSelect: React.FC = () => {
	const { IDsSelectedClientType, setIDsClientType } = useContext<IRestaurantsContext>(RestaurantsContext);
	const parentNodeRef = useRef<null | HTMLSpanElement>(null);
	const { t } = useTranslation('listing');

	const handleSelect = (value: TTypeOfServiceProvided[]) => {
		setIDsClientType(value);
	};

	return (
		<div className={style.container} data-test="ClientTypeMultipleSelect">
			<Text translationNameSpace="listing" translationKey="clientTypeLabel" theme="neutralLight" size="xs" />
			<span ref={parentNodeRef} style={{ position: 'relative' }} />
			<Select
				className={style.select}
				onChange={handleSelect}
				value={IDsSelectedClientType}
				listItemHeight={clientTypes.length}
				mode="multiple"
				showArrow={true}
				showSearch={false}
				removeIcon={false}
				menuItemSelectedIcon={null}
				allowClear={true}
				getPopupContainer={() => parentNodeRef.current as HTMLSpanElement}
				placeholder={t('selectPlaceholder')}>
				{clientTypes.length ? (
					<>
						<Option className={style.disabledItem} value="empty" disabled={true}>
							{t('selectAnyItemPlaceholder')}
						</Option>
						{clientTypes.map((el) => (
							<Option className={style.listItem} value={el.clientTypeID} key={el.clientTypeID}>
								<svg className={style.icon}>
									<use xlinkHref={`${breadcrumbs}#${el.clientTypeName}`} />
								</svg>
								{t(el.clientTypeName)}
							</Option>
						))}
					</>
				) : null}
			</Select>
		</div>
	);
};

export default ClientTypeMultipleSelect;
